import moment from 'moment'
import request from '@/utils/request'
// import axios from 'axios'
// const request = axios.create({
//   baseURL: 'http://zcoa5.yuyiit.com'
// })z

// 获取投标数据统计（按时间）投标
export const getTbsjtjAsjTb = () => {
  return request('/manage/mst_zcoa_xmgl_tbwjxx/list1', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'TByearnum',
      TBnum: 'TBnum'
    }
  })
}

// 获取投标数据统计（按时间）中标
export const getTbsjtjAsjZb = () => {
  return request('/manage/mst_zcoa_xmgl_tbwjxx/list', {
    method: 'post',
    data: {
      rate: 'rate',
      jn: moment().format('YYYY'),
      queryType: 'ZByearnum',
      ZByearrate: 'ZByearrate'
    }
  })
}

// 获取投标数据统计（按部门）投标
export const getTbsjtjAbmTb = (total = false) => {
  return request('/manage/mst_zcoa_xmgl_tbwjxx/list2', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'BMTB',
      BMZBrate: total ? 'BMZBrate' : undefined
    }
  })
}

// 获取投标数据统计（按部门）中标
export const getTbsjtjAbmZb = (total = false) => {
  return request('/manage/mst_zcoa_xmgl_tbwjxx/list3', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'BMZB',
      BMZBrate: total ? 'BMZBrate' : undefined
    }
  })
}

// 获取签约数据统计（按时间）签约数
export const getQysjtjAsjQys = () => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'qyhtnum',
      qyhtyearnum: 'qyhtyearnum'
    }
  })
}

// 获取签约数据统计（按时间）签约额
export const getQysjtjAsjQye = () => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list1', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'qyhtHJ',
      qyhtyearHJ: 'qyhtyearHJ'
    }
  })
}

// 获取签约数据统计（按部门）签约数
export const getQysjtjAbmQys = () => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list2', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'bmqyhtnum'
    }
  })
}

// 获取签约数据统计（按部门）签约额
export const getQysjtjAbmQye = () => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list3', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'bmqyhtHJ'
    }
  })
}

// 获取签约数据统计（按签约个人）签约数
export const getQysjtjAqygrQys = () => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list4', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'qygrnum'
    }
  })
}

// 获取签约数据统计（按签约个人）签约额
export const getQysjtjAqygrQye = () => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list5', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'qygrHJ'
    }
  })
}

// 获取签约数据统计（按承担部门）签约数
export const getQysjtjAcdbmQys = () => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list8', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'cdbmnum'
    }
  })
}

// 获取签约数据统计（按承担部门）签约额
export const getQysjtjAcdbmQye = () => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list9', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'cdbmHJ'
    }
  })
}

// 获取签约数据统计（按项目类别）签约数
export const getQysjtjAxmlbQys = () => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list6', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'xmlbqynum'
    }
  })
}

// 获取签约数据统计（按项目类别）签约额
export const getQysjtjAxmlbQye = () => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list7', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType: 'xmlbqyHJ'
    }
  })
}

// 获取本年度收发合同统计
export const getBndsfhttj = () => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list10', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
    }
  })
}

// 获取本年度收发合同统计明细
export const getBndsfhttjmx = (queryType) => {
  return request('/manage/mst_zcoa_xmk_xmxx_ht/list11', {
    method: 'post',
    data: {
      jn: moment().format('YYYY'),
      queryType
    }
  })
}

// 获取待投标结构项目
export const getDtbjgxm = () => {
  return request('/manage/mst_zcoa_xmgl_tbwjxx/list4', {
    method: 'post',
    data: {
      queryType: 'tbr'
    }
  })
}
